import Button from '@amzn/awsui-components-core/button';
import React from 'react';
import { useVersionDropdown } from 'src/components/star-grid/hooks/useVersionDropdown';
import { useVersionRangeCalendar } from 'src/components/star-grid/hooks/useVersionRangeCalendar';
import styles from 'src/components/star-grid/components/styles/ReportVersionSelector.module.scss';

type State = ReturnType<typeof useVersionDropdown>;

export const ReportVersionRangeCalendar: React.FC<{ readonly state: State }> = ({ state }) => {
  const calendar = useVersionRangeCalendar(state.dates);
  return (
    <>
      <div className={styles.calendarBar}>
        <span>{state.text(state.dates.activeField === 'endDate' ? 'versionChooseEnd' : 'versionChooseStart')}</span>
        <div className={styles.calendarNavigation}>
          <Button
            variant="icon"
            iconName="angle-left"
            ariaLabel={state.text('versionCalendarPrevious')}
            formAction="none"
            onClick={() => calendar.moveMonth(-1)}
            data-testid="version-calendar-previous"
          />
          <Button
            variant="icon"
            iconName="angle-right"
            ariaLabel={state.text('versionCalendarNext')}
            formAction="none"
            onClick={() => calendar.moveMonth(1)}
            data-testid="version-calendar-next"
          />
        </div>
      </div>
      <div className={styles.calendars} ref={calendar.ref} data-testid="version-range-calendar">
        {calendar.months.map((month) => (
          <div className={styles.month} key={month.month}>
            <h3>{month.label}</h3>
            <div role="grid" aria-label={month.label}>
              <div className={styles.calendarWeek} role="row">
                {calendar.weekdays.map((day) => (
                  <span className={styles.weekday} role="columnheader" aria-label={day.label} key={day.label}>
                    {day.short}
                  </span>
                ))}
              </div>
              {month.weeks.map((week, index) => (
                <div className={styles.calendarWeek} role="row" key={index}>
                  {week.map((day, column) => (
                    <span role="gridcell" key={day?.date ?? column} aria-selected={Boolean(day?.endpoint || day?.withinRange)}>
                      {day && (
                        <Button
                          variant="inline-link"
                          formAction="none"
                          ariaLabel={day.label}
                          onClick={() => calendar.choose(day.date)}
                          data-testid={`version-day-${day.date}`}
                          nativeButtonAttributes={{
                            'data-date': day.date,
                            'data-endpoint': String(day.endpoint),
                            'data-in-range': String(day.withinRange),
                            'aria-current': day.today ? 'date' : undefined,
                            tabIndex: day.date === month.tabStop ? 0 : -1,
                            onKeyDown: (event) => calendar.keyDown(event, day.date)
                          }}
                        >
                          {day.number}
                        </Button>
                      )}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
